<mat-toolbar class="topbar header">
  <div id="mainSection">

  <div id="leftSection">
    <app-branding></app-branding>

    <!-- --------------------------------------------------------------- -->
    <!-- Desktop Menu -->
    @if(showToggle) {
    <button
      mat-icon-button
      (click)="toggleCollapsed.emit()"
      class="d-flex justify-content-center"
    >
      <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
    </button>
    }
  
    <!-- Mobile Menu -->
    @if(!showToggle) {
    <button
      mat-icon-button
      (click)="toggleMobileNav.emit()"
      class="d-flex justify-content-center"
    >
      <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
    </button>
    }
  
  </div>

  <div id="rightSection">
  <!-- --------------------------------------------------------------- -->

  <!-- --------------------------------------------------------------- -->
  <!-- langugage Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <button [matMenuTriggerFor]="flags" mat-icon-button class="m-r-5">
    <img [src]="selectedLanguage.icon" class="rounded object-cover icon-25" />
  </button>
  <mat-menu #flags="matMenu" class="cardWithShadow">
    @for(lang of languages; track lang.language) {
    <button mat-menu-item (click)="changeLanguage(lang)">
      <div class="d-flex align-items-center">
        <img [src]="lang.icon" class="rounded object-cover m-r-8 icon-20" />
        <span class="mat-subtitle-1 f-s-14">{{ lang.language }}</span>
      </div>
    </button>
    }
  </mat-menu>

  <!-- --------------------------------------------------------------- -->
  <!-- Notification Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <!-- <button
    mat-icon-button
    [matMenuTriggerFor]="notificationmenu"
    aria-label="Notifications"
  >
    <i-tabler name="bell" class="icon-18 m-r-4"></i-tabler>
    <span class="badge badge-notification blink"></span>
  </button> -->
  <mat-menu #notificationmenu="matMenu" class="topbar-dd cardWithShadow">
    <div class="d-flex align-items-center p-x-32 p-y-16">
      <h6 class="f-s-16 f-w-600 m-0 mat-subtitle-1">Notifications</h6>
      <span class="m-l-auto">
        <span class="bg-primary text-white p-x-8 p-y-4 f-w-500 rounded f-s-12"
          >5 new</span
        >
      </span>
    </div>
    @for(notification of notifications; track notification.id) {
    <button mat-menu-item class="p-x-32 p-y-16">
      <div class="d-flex align-items-center">
        <img [src]="notification.img" class="rounded-circle" width="48" />
        <div class="m-l-16">
          <h5 class="f-s-14 f-w-600 m-0 mat-subtitle-1">
            {{ notification.title }}
          </h5>
          <span>{{ notification.subtitle }}</span>
        </div>
      </div>
    </button>
    }

    <div class="p-y-12 p-x-32">
      <button mat-stroked-button color="primary" class="w-100">
        See all notifications
      </button>
    </div>
  </mat-menu>

  <!-- --------------------------------------------------------------- -->
  <!-- User manual -->
  <!-- --------------------------------------------------------------- -->

  <a href="/assets/AuthoringToolUserManual.html?lang={{selectedLanguage.code}}" target="_blank" style="display: flex;">
  <i-tabler name="help" class="headerIcon"></i-tabler>
</a>

  <!-- --------------------------------------------------------------- -->
  <!-- profile Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <button
    mat-icon-button
    [matMenuTriggerFor]="profilemenu"
    aria-label="Notifications"
  >
    <img
      src="/assets/images/profile/profile.png"
      class="rounded-circle object-cover icon-25" style="margin-left: -5px !important;"
      width="35"
    />
  </button>
  
  <mat-menu #profilemenu="matMenu" class="topbar-dd cardWithShadow">
      <div class="p-x-32 p-y-16">
        <h6 class="f-s-16 f-w-600 m-0 mat-subtitle-1">User Profile</h6>

        <div class="d-flex align-items-center p-b-24 b-b-1 m-t-16">
          <div>
            <h6 class="f-s-14 f-w-600 m-0 mat-subtitle-1"> {{userData.firstname}} {{userData.lastname}}</h6>
            <span style="color: gray; font-size: 13px;">{{userData.email}}</span>
            <!-- <span class="f-s-14 d-block m-b-4">Designer</span> -->
            <!-- <span class="d-flex align-items-center">
              <i-tabler name="mail" class="icon-15 m-r-4"></i-tabler>
              info&#64;materialpro.com
            </span> -->
          </div>
        </div>
      </div>



       <div class="p-y-12 p-x-32">
        <a [href]="'mailto:' + supportEmail + '?subject= ' + emailSubject + userId + '&body=' + emailBody"
          mat-stroked-button
          color="primary"
          class="w-100"
          >
          <span style="width: 100%; display: flex; justify-content: center;">
          <i-tabler name="alert-square" class="icon-20 d-flex" style="margin-right: 10px;stroke: rgb(49 50 128);"></i-tabler>
          {{'home.reportProblem' | translate}}
          </span>
         </a>
      </div>

      <div class="p-y-12 p-x-32">
        <a
          (click)="logout()"
          mat-stroked-button
          color="primary"
          class="w-100"
          style="background-color: #313280; color: white;"
          >{{'home.logout' | translate}}</a>
      </div>
  </mat-menu>
  

</div>
</div>
</mat-toolbar>
